import { z } from 'zod';

import { LiquidationRecordInput } from '../../loan/LiquidationRecord';
import { BaseLoanEvent } from '../BaseLoanEvent';

/**
 * @deprecated use LiquidateLoanEvent instead
 * Followup i11086 - remove this event after migrating v1 liquidations
 */
export const RecordLiquidationEvent = BaseLoanEvent.extend({
  type: z.literal('recordLiquidation'),
  input: LiquidationRecordInput,
});
export type RecordLiquidationEvent = z.infer<typeof RecordLiquidationEvent>;
